/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Identity_HeadlineInputs */

const en_identity_headline = /** @type {(inputs: Identity_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`While others scroll, you choose to focus with Forest`)
};

const de_identity_headline = /** @type {(inputs: Identity_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Andere scrollen durch ihr Handy – du nutzt Forest, um fokussiert zu bleiben`)
};

const zh_tw_identity_headline = /** @type {(inputs: Identity_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`別人在滑手機的時候，你選擇用 Forest 進行專注`)
};

const zh_cn_identity_headline = /** @type {(inputs: Identity_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`别人在刷手机的时候，你选择用 Forest 保持专注`)
};

const es_identity_headline = /** @type {(inputs: Identity_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mientras otros se pierden en el móvil, tú eliges enfocarte con Forest`)
};

const fr_identity_headline = /** @type {(inputs: Identity_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pendant que d'autres scrollent, toi tu choisis de te concentrer avec Forest`)
};

const it_identity_headline = /** @type {(inputs: Identity_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mentre altri scrollano, tu scegli di restare concentrato con Forest`)
};

const pt_br_identity_headline = /** @type {(inputs: Identity_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enquanto outros ficam rolando o feed, você escolhe focar com o Forest`)
};

const ja_identity_headline = /** @type {(inputs: Identity_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`みんながスマホをダラダラ見てる時間に、あなたは Forest で集中することを選びました`)
};

const ko_identity_headline = /** @type {(inputs: Identity_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다른 사람들이 폰을 만지작거릴 때, 당신은 Forest로 집중을 택했죠`)
};

const ru_identity_headline = /** @type {(inputs: Identity_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пока другие залипают в телефоне, ты выбираешь фокус с Forest`)
};

const th_identity_headline = /** @type {(inputs: Identity_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตอนที่คนอื่นไถมือถือเล่น คุณเลือกใช้ Forest เพื่อโฟกัส`)
};

const tr_identity_headline = /** @type {(inputs: Identity_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başkaları telefonla oyalanırken, sen Forest ile odaklanmayı seçtin`)
};

const ar_identity_headline = /** @type {(inputs: Identity_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بينما الآخرون يتصفحون هواتفهم، أنت اخترت التركيز مع Forest`)
};

/**
* | output |
* | --- |
* | "While others scroll, you choose to focus with Forest" |
*
* @param {Identity_HeadlineInputs} inputs
* @param {{ locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }} options
* @returns {LocalizedString}
*/
export const identity_headline = /** @type {((inputs?: Identity_HeadlineInputs, options?: { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Identity_HeadlineInputs, { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_identity_headline(inputs)
	if (locale === "de") return de_identity_headline(inputs)
	if (locale === "zh_tw") return zh_tw_identity_headline(inputs)
	if (locale === "zh_cn") return zh_cn_identity_headline(inputs)
	if (locale === "es") return es_identity_headline(inputs)
	if (locale === "fr") return fr_identity_headline(inputs)
	if (locale === "it") return it_identity_headline(inputs)
	if (locale === "pt_br") return pt_br_identity_headline(inputs)
	if (locale === "ja") return ja_identity_headline(inputs)
	if (locale === "ko") return ko_identity_headline(inputs)
	if (locale === "ru") return ru_identity_headline(inputs)
	if (locale === "th") return th_identity_headline(inputs)
	if (locale === "tr") return tr_identity_headline(inputs)
	return ar_identity_headline(inputs)
});